var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getShowComponent)?_c('div',{attrs:{"data-component":"upload-preview"}},[(_vm.getPreviewComponent)?_c(_vm.getPreviewComponent,{tag:"component",attrs:{"src":_vm.getSrc}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }